export default __webpack_public_path__ + "static/media/gallery-1.731e63ff.png";